import type { ETimeDimension } from '~/core/gemxql/types';

import { AnalyticInterval } from '~/modules/analytics/types';

export const TIME_DIMENSION_TO_INTERVAL: Record<ETimeDimension, AnalyticInterval> = {
  hour: AnalyticInterval.HOUR,
  day: AnalyticInterval.DAY,
  week: AnalyticInterval.WEEK,
  month: AnalyticInterval.MONTH,
  quarter: AnalyticInterval.QUARTER,
  year: AnalyticInterval.YEAR,
};
